export const exhaustiveGuard = (
  shouldBeNeverValue: never,
  message?: string
): never => {
  throw new Error(`${message || "Unexpected object"}: ${shouldBeNeverValue}`);
};

export const exhaustiveGuardNoError = (_shouldBeNeverValue: never): void => {
  return;
};

export const exhaustiveGuardWithDefaultValue = <T>(
  _shouldBeNeverValue: never,
  defaultValue: T
): T => {
  return defaultValue;
};
